module.exports = __webpack_public_path__ + "img/Orbiting-Inspect-Large.d4dcd1bf.png";